module.exports = __webpack_public_path__ + "images/avatars/female/2.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/2.png
// module id = f37r
// module chunks = 153